import React from "react";

import { DatePicker, Form, Row } from "antd";

import moment from "moment/moment";
import Swal from "sweetalert2";

const { RangePicker } = DatePicker;
const CooperatePeriod = ({
  isEdit,
  searchOptions,
  setSearchOptions,
  standardSearchOptions,
}) => {
  const handleRangeDate = (value) => {
    const [start, end] = value;
    let selectedStart;
    let selectedEnd;
    let dateValidation;

    if (isEdit) {
      // 공구 수정: 기존에 등록된 공구 시작일부터 선택 가능
      dateValidation =
        moment(end).startOf("minute").diff(moment(start).startOf("minute")) > 0;
    } else {
      // 공구 등록: 오늘 날짜부터 선택 가능
      dateValidation =
        moment(start).startOf("day").diff(moment().subtract(1, "day")) > 0 &&
        moment(end).startOf("minute").diff(moment(start).startOf("minute")) > 0;
    }

    if (dateValidation) {
      if (searchOptions.startDate !== start) {
        selectedStart = start;
      }
      if (searchOptions.endDate !== end) {
        selectedEnd = end;
      }
      setSearchOptions({
        startDate: selectedStart ? selectedStart : searchOptions.startDate,
        endDate: selectedEnd ? selectedEnd : searchOptions.endDate,
      });
    } else {
      Swal.fire({
        title: isEdit
          ? "공구 마감일을 다시 선택해주세요."
          : "오늘 날짜부터 선택 가능합니다.",
        customClass: "custom-alert",
        confirmButtonColor: "#117ffa",
        confirmButtonText: "확인",
      });
    }
  };

  return (
    <>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ marginTop: 20 }}
      >
        <span className="product-register-box-title">공구기간</span>
        <span className="product-register-box-sign">*</span>
      </Row>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ borderTop: 0, width: "100%" }}
      >
        <Form.Item
          className="center-label"
          label="기간설정"
          labelAlign="left"
          colon={false}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
          style={{ margin: 0, width: "100%" }}
        >
          <Row align={"middle"} style={{ gap: "0.5rem" }}>
            <RangePicker
              showTime={{
                format: "a HH:mm",
              }}
              format="YYYY/MM/DD a HH:mm"
              className="order-search-date-wrap"
              allowClear={false}
              value={[searchOptions.startDate, searchOptions.endDate]}
              onChange={handleRangeDate}
            />
          </Row>
        </Form.Item>
      </Row>
    </>
  );
};

export default CooperatePeriod;
